import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import moment from 'moment';
import { ContratistaService } from 'src/app/services/contratista.service';
import { FacturacionService } from 'src/app/services/facturacion.service';
import { LicenciaService } from 'src/app/services/licencia.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-pago-ok',
  templateUrl: './pago-ok.component.html',
  styleUrls: ['./pago-ok.component.scss']
})
export class PagoOkComponent implements OnInit {

idFactura:any
userLog:any
licenciasPagadas:any
facturas:any =[]
customId:any
idCustomFactura:any
baseImponible:any
total:any
iva:any
numeroLicencias:any
fechaPago:any
cliente:any

  constructor(
    private facturaService: FacturacionService, 
    private apollo:Apollo, 
    private licenciaService:LicenciaService,
    private contratistaService: ContratistaService,
    private loginService: LoginService, 
    private http: HttpClient) { 

    this.userLog = loginService.getUserData();
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    this.idFactura= urlParams.get('res');
    
    
    }


   


  ngOnInit(): void {

    this.getFacturaById()
   
    
  }

 


  getFacturaById() {
    this.apollo.watchQuery<any>({
      query: this.facturaService.getFacturaById(),
      variables: {
        "id": this.idFactura
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
       
       console.log(data);
       this.idCustomFactura = data.factura.numeroFactura
       this.baseImponible = data.factura.baseImponible
       this.numeroLicencias = data.factura.numeroLicencias
       this.iva = data.factura.iva
       this.total = data.factura.precioTotal
       this.cliente = data.factura.cliente.id
       this.fechaPago = moment(new Date()).format('DD/MM/YYYY')
       
      
        }
      )
  }

  
}
